import Button, { ButtonTypes } from '@/components/Buttons/Button';
import { Divider, Text, Textarea } from '@mantine/core';

import { API_ENDPOINT } from '@/config/endpoint';
import CommentCard from '@/components/Comment/CommentCard';
import ConfirmationPopup from '@/components/ConfirmationPopup';
import DMText from '@/components/DMText';
import { createDiscussionDetailPageStyles } from '@/features/Discussion/discussion.style';
import { isSignedIn } from '@/config/globalStateControl';
import themeVariables from '@/styles/themeVariables';
import { useAtomValue } from 'jotai';
import { useReplaceQueryParams } from '@/utils/utils';
import { useState } from 'react';

const CommentContainer = ({
  topicData,
  comments,
  refetchTopicData,
  refetchComment,
  type,
}) => {
  const isLogin = useAtomValue(isSignedIn);

  const { classes } = createDiscussionDetailPageStyles();
  const { queryParams } = useReplaceQueryParams();

  const [newComment, setNewComment] = useState('');

  const handleLikeComment = async (commentId, enable_like) => {
    await API_ENDPOINT.comment
      .updateCommentLikeCount(commentId, !enable_like)
      .then(() => {
        refetchComment();
      });
  };

  const handleEditComment = async (_, commentId, text) => {
    if (!isLogin || text.length == 0) {
      return;
    }

    await API_ENDPOINT.comment.editComment(commentId, text).then(() => {
      refetchComment();
    });
  };

  const handleAddComment = async (parentId, text) => {
    if (!isLogin || text.length == 0) {
      return;
    }

    const testId = queryParams.get('test_id') || '';

    const typeId = testId
      ? testId + ':' + topicData?.item.id
      : topicData?.item.id;

    await API_ENDPOINT.comment
      .addComment(type, typeId, parentId, text)
      .then(() => {
        refetchTopicData();
        refetchComment();
      });

    setNewComment('');
  };

  const handleDeleteComment = (commentId) => {
    ConfirmationPopup.confirm('댓글을 삭제하시겠습니까?', async () => {
      await API_ENDPOINT.comment.deleteComment(commentId).then(() => {
        refetchTopicData();
        refetchComment();
      });
    });
  };

  const handleSubmitNewCommentButton = async () => {
    await handleAddComment(null, newComment);
    setNewComment('');
  };

  return (
    <>
      <Divider mb={40} color={themeVariables.line.alternative} />
      <DMText
        dColor={themeVariables.darkMode.normal}
        weight={600}
        size={20}
        lh={'26px'}
        mb={33}
      >
        댓글{' '}
        <Text span color={themeVariables.label.alternative}>
          {(comments?.items?.length || 0) +
            (comments?.items?.flatMap((item) => item.children)?.length || 0)}
        </Text>
      </DMText>
      {comments &&
        comments?.items?.map((comment, index) => (
          <div className={'fadeInUpAnimation'} key={index}>
            <CommentCard
              comment={comment}
              nestedComment={comment.children}
              handleAddComment={handleAddComment}
              handleLikeComment={handleLikeComment}
              handleEditComment={handleEditComment}
              handleDeleteComment={handleDeleteComment}
            />
          </div>
        ))}
      <Textarea
        minRows={3}
        value={newComment}
        disabled={!isLogin}
        placeholder={
          isLogin ? '댓글을 남겨주세요.' : '로그인 후에 댓글을 남겨주세요.'
        }
        onChange={(e) => setNewComment(e.target.value)}
        sx={{
          borderRadius: 10,
        }}
      />
      <div className={classes.addCommentButtonContainer}>
        <Button
          type={
            newComment.length > 0 && isLogin
              ? ButtonTypes.gray
              : ButtonTypes.disabled
          }
          onClick={handleSubmitNewCommentButton}
        >
          등록하기
        </Button>
      </div>
    </>
  );
};

export default CommentContainer;
